import { UserCommunication } from '@this+that/models';

import { ShortcutContext } from './types';
import { useEmailListNavigation } from './useEmailListNavigation';

interface UseAllMailNavigationProps {
  filteredCommunications: UserCommunication[];
}

export function useAllMailNavigation({
  filteredCommunications,
}: UseAllMailNavigationProps) {
  return useEmailListNavigation({
    filteredCommunications,
    context: ShortcutContext.ALL_MAIL,
  });
}
